var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSections = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4178 4.90862C22.546 5.15939 22.5229 5.46085 22.358 5.68918L12.608 19.1892C12.467 19.3844 12.2408 19.5001 12 19.5001C11.7592 19.5001 11.533 19.3844 11.392 19.1892L1.64199 5.68918C1.47709 5.46085 1.454 5.15939 1.58223 4.90862C1.71045 4.65785 1.96835 4.50006 2.25 4.50006L21.75 4.50006C22.0316 4.50006 22.2895 4.65785 22.4178 4.90862ZM20.2832 6.00006L3.71681 6.00006L12 17.4691L20.2832 6.00006Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSections);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sections.4588a81134a2f0c01640f715498a30d1.svg";